<template>
  <div
    class="cpt-seckill-sale"
    :style="{
      'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
      'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
      'background-color': cc.bg_color || '#FFFFFF',
      'min-height': cc.full_page ? '100vh' : '0'
    }"
  >
    <!-- <div class="header-img" :style="{ 'margin-bottom': `${cc.header_img_margin_bottom}%` }">
      <img v-src="cc.header_img">
    </div> -->
    <div class="content" :style="{ 'background': calcGradientBg(cc.content_color, 'bottom') || '#303030', }">
      <cpt-count-down 
        :cur-time="curTime"
        :time-list="timeList"
        :subscribe-state="curSubscribeState"
        :cc="cc"
        @subscribe="handleSubscribe"
      ></cpt-count-down>
      <cpt-sale-days
        :cur-time="curTime"
        v-show="cc.show_sales_day"
        :time-list="timeList"
        :cc="cc"
        :activeDayIndex.sync="activeDayIndex"
      ></cpt-sale-days>
      <div class="sku-list">
        <cpt-sku-item
          v-for="sku in activeSaleList"
          :key="`${sku.sku_id || sku.package_id}-${activeDayIndex}`"
          :sku="sku"
          :cur-time="curTime"
          :cc="cc"
          :gradient-style="skuGradientStyle"
        ></cpt-sku-item>
      </div>
      <div class="footer">
        <div class="footer-desc">- 成交价以订单结算页价格为准 -</div>
        <!-- <div class="footer-img">
          <img v-src="'https://imgheybox.max-c.com/oa/2024/02/26/6eb289002a7d7377026691c888a20a98.png'">
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { ComponentCommonMixin } from '../../mixin'
import OrderMixin from '../../mixins/order'
import CptCountDown from './components/CptCountDown.vue'
import CptSaleDays from './components/CptSaleDays.vue'
import CptSkuItem from './components/CptSkuItem.vue'
import { getSecKillSales, subscribeWeeklySale } from '_api/activity-common-template'
import { showMessage, executeProtocol, getUrlParam, geVersion, hexToRgba } from '_lib/utils'

export default {
  mixins: [ComponentCommonMixin, OrderMixin],
  components: {
    CptCountDown,
    CptSaleDays,
    CptSkuItem,
  },
  data () {
    return {
      curTime: Math.ceil(new Date().getTime() / 1000),
      updateTimer: null,
      saleList: [],
      timeList: [],
      refreshTimerList: [],
      activeDayIndex: 0,
    }
  },
  mounted () {
    this.initTimer()
    this.getData()
  },
  computed: {
    activeSaleList() {
      return this.saleList[this.activeDayIndex]?.sales || []
    },
    curSubscribeState() {
      return this.saleList[this.activeDayIndex]?.sub_state 
    },
    tagBg () {
      const colors = this.cc.tag_bg_color.split(',')
      if (colors.length === 1) return colors[0]
      return `linear-gradient(to right, ${colors[0]} 0%, ${colors[1]} 100%)`
    },
    opBtnNormalBg() {
      const colors = this.cc.op_btn_highlight_bg.split(',')
      if (colors.length === 1) return hexToRgba(colors[0], 0.5)
      return `linear-gradient(to right, ${hexToRgba(colors[0], 0.5)} 0%, ${hexToRgba(colors[1], 0.5)} 100%)`
    },
    skuGradientStyle() {
      return {
        tagBg: this.tagBg,
        opBtnHighlightBg: this.calcGradientBg(this.cc.op_btn_highlight_bg, 'right'),
        opBtnNormalBg: this.opBtnNormalBg,
        opBtnBannedBg: this.calcGradientBg(this.cc.op_btn_end_bg, 'right'),
      }
    }
  },
  methods: {
    async getData() {
      let res = await getSecKillSales({
        heybox_id: this.querys.heybox_id,
        act_id: this.act_id,
      })
      let { status, result } = res.data
      // let { status, result } = require('./mock.json')
      if(status == 'ok') {
        this.saleList = result.act_list || []
        this.emptyRefreshTimer()
        this.timeList = this.saleList.map(sale => {
          this.addRefreshTimer(sale.start_time)
          this.addRefreshTimer(sale.end_time)
          return {
            'start_time': sale.start_time,
            'end_time': sale.end_time
          }
        })
        let nextEndIndex = this.timeList.findIndex(day => {
          return day.end_time > this.curTime
        })
        this.activeDayIndex = nextEndIndex == -1 ? (this.timeList.length - 1) : nextEndIndex
      }
    },
    initTimer() {
      this.updateTimer = setInterval(() => {
        this.curTime = Math.ceil(new Date().getTime() / 1000)
      }, 1000)
    },
    addRefreshTimer(second) {
      let remain = second - this.curTime
      if(remain > 0) {
        let timer = setTimeout(() => {
          this.getData()
        }, remain * 1000)
        this.refreshTimerList.push(timer)
      }
    },
    emptyRefreshTimer() {
      this.refreshTimerList.forEach((timer) => {
        clearTimeout(timer)
      })
      this.refreshTimerList = []
    },
    async handleSubscribe(isSubscribe) {
      if(this._subscribeLock) return
      this._subscribeLock = true
      let res = await subscribeWeeklySale({
        heybox_id: this.querys.heybox_id,
        value: isSubscribe,
        sale_id: this.saleList[this.activeDayIndex].sale_id,
      })
      let { status, result } = res.data
      if(status == 'ok') {
        if(isSubscribe) {
          showMessage('ok', '秒杀开始前3分钟将以App推送的方式提醒您，请检查是否开启推送通知', '提醒已开启')
        } else {
          showMessage('ok', '您可能错过秒杀哦', '提醒已取消')
        }
        this.$set(this.saleList[this.activeDayIndex], 'sub_state', isSubscribe)
      } else {
        showMessage('failed', res.data.msg || '取消失败')
      }
      this._subscribeLock = false
    },
    calcGradientBg(str, direction) {
      if(!str) {
        return ''
      }
      const colors = str.split(',')
      switch(colors.length) {
        case 1: 
          return colors[0]
        case 2: 
          return `linear-gradient(to ${direction}, ${colors[0]} 0%, ${colors[1]} 100%)`
        default:
          return str
      }
    }
  },
  filters: {

  }
}
</script>

<style lang="less" scoped>
.cpt-seckill-sale {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .header-img {
    width: 100%;
    padding-bottom: 53.33%; //375 * 200
    position: relative;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .content {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background: #303030;
    border-radius: 12px 12px 0 0;
    .sku-list {
      width: 100%;
      padding: 0 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
    }
    .footer {
      width: 100%;
      padding: 20px 0 15px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      .footer-desc {
        line-height: 14px;
        font-size: 10px;
        color: #7A7A7A;
      }
      .footer-img {
        margin-top: 15px;
        img {
          height: 18px;
        }
      }
    }
  }
}
</style>